import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tom-select"
// Generic TomSelect initializer — attach to any <select> that needs a searchable dropdown.
export default class extends Controller {
  connect() {
    this.select = new TomSelect(this.element, {
      sortField: { field: "text", direction: "asc" },
      maxOptions: null
    })
  }

  disconnect() {
    this.select?.destroy()
  }
}
